/**
 * 支付方式
 * @type {{aliPay: number, caiBi: number, weXin: number, unKnow: number}}
 */
export const PaymentMethods = {
  /**
   * 未知(此时一般用于创建订单尚未支付阶段，支付成功后更新状态)
   */
  unKnow: 0,
  /**
   * 微信
   */
  weXin: 1,
  /**
   * 支付宝
   */
  aliPay: 2,
  /**
   * 财币
   */
  caiBi: 3,
  /**
   * 苹果支付
   */
  apple: 4
}
